import { render, staticRenderFns } from "./DialogNovoCliente.vue?vue&type=template&id=12c7e8e9&scoped=true&"
import script from "./DialogNovoCliente.vue?vue&type=script&lang=js&"
export * from "./DialogNovoCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c7e8e9",
  null
  
)

export default component.exports